import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Stack } from '@lyearn/ui';
import Dialog from '@/components/Modals/Dialog';

import DialogContent from './components/DialogContent';
import { dialogStyles } from './styles';
import useVersionHistory from './useVersionHistory';

const dialogClasses = {
  paper: dialogStyles,
};

interface VersionHistoryDialogProps {
  contentId: string;
  onClose: () => void;
}

const VersionHistoryDialog: React.FC<VersionHistoryDialogProps> = ({ contentId, onClose }) => {
  const { t } = useTranslation();
  const { initialFetching, versionsHistory, fetchMore } = useVersionHistory(contentId);

  return (
    <Dialog
      className="flex flex-1"
      classes={dialogClasses}
      header={{
        title: t('Admin:VersionHistory.Header'),
      }}
      onClose={onClose}>
      <Stack className="flex flex-1 px-32">
        <DialogContent
          fetchMore={fetchMore}
          initialFetching={initialFetching}
          versionsHistory={versionsHistory}
        />
      </Stack>
    </Dialog>
  );
};

export default VersionHistoryDialog;
